
import { CreateElement, VNode, VNodeChildren } from 'vue';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { EVENTS } from '../../bus/events.const';

const defaultClass = 'ebx-spellcheck-message';

@Component
export default class Spellcheck extends Vue {
  @Prop({ required: true })
  query: string;

  @Prop({ required: true })
  spellcheck: string;

  get messageSplitted(): string[] {
    return this.$x.messages.spellcheck.split(/[{}]/g);
  }

  get childrenElements(): VNodeChildren {
    return this.messageSplitted.map(messagePart => {
      switch (messagePart) {
        case 'query':
          return this.createHighlightElement();
        case 'spellcheck':
          return this.createEventElement();
        default:
          return messagePart;
      }
    });
  }

  render(createElement: CreateElement) {
    return createElement('p', {
      class: defaultClass
    }, this.childrenElements);
  }

  createHighlightElement(): VNode {
    return this.$createElement('span', {
      class: `${ defaultClass }__highlight`
    }, this.query);
  }

  createEventElement(): VNode {
    return this.$createElement('button', {
      class: `${ defaultClass }__event`,
      on: { click: this.eventTrigger }
    }, this.spellcheck);
  }

  eventTrigger() {
    this.$x.emit(EVENTS.SpellcheckSelected, this.spellcheck);
  }
}
